import { cn } from '@/utils/helpers';
import type { ReactNode } from 'react';

interface ChatMessageProps {
  content: ReactNode;
  isCurrentUserMessage?: boolean;
  avatar?: ReactNode;
}

export function ChatMessage({ content, isCurrentUserMessage = false, avatar }: ChatMessageProps) {
  return (
    <div className="flex gap-3 mb-6">
      <div className={cn('flex-1 flex gap-2', isCurrentUserMessage ? 'flex justify-end' : '')}>
        {!isCurrentUserMessage && avatar && <div className="pt-0.5">{avatar}</div>}

        <div
          className={cn(
            'text-text-primary',
            isCurrentUserMessage
              ? 'max-w-[80%] max-[800px]:max-w-full bg-stone-50 rounded-xl p-4'
              : 'w-full'
          )}
        >
          <div 
            className={cn(
              'flex flex-col text-sm leading-relaxed',
              'overflow-y-auto'
            )}
            style={{
              scrollbarWidth: 'thin',
              scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
            }}
          >
            <div>{content}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
